module.exports = __webpack_public_path__ + "img/sistecredito.49a2d802.svg";